export class Config {
  element: string;
  value: Array<any>;
  active: boolean;
}
